import { DEX_SESSION_LOCATION } from '~appointments/components/dexFields';

// Display labels for appointment_dex_details columns - the raw column names copy_preview returns
// from the API (TAV-3133 follow-up, Beth Kairys review feedback: show exactly what a copy will
// write, rather than sending the user to the parent's full DEX tab to work it out themselves).
export const DEX_COPY_FIELD_LABELS: Record<string, string> = {
  subcontractor: 'Subcontractor',
  volunteer: 'Volunteer',
  session_location: 'Session location',
  overnight: 'Overnight',
  meals_provided: 'Meals provided',
  meals_cooked_offsite: 'Meals cooked offsite',
  texture_modified: 'Texture modified',
  meal_type_main: 'Meals - main',
  meal_type_light: 'Meals - light',
  meal_type_dessert: 'Meals - dessert',
  meal_type_beverage: 'Meals - beverage',
  meal_type_snack: 'Meals - snack',
  engagement_time_minutes: 'Engagement time (minutes)',
  trip_distance_km: 'Trip distance (km)',
  trip_travel_time_minutes: 'Trip travel time (minutes)',
};

const SESSION_LOCATION_LABELS: Record<number, string> = {
  [DEX_SESSION_LOCATION.HOME]: 'Home',
  [DEX_SESSION_LOCATION.COMMUNITY]: 'Community',
};

function formatDexCopyPreviewValue(column: string, value: string | number | boolean | null): string {
  if (value === null) return '—';
  if (typeof value === 'boolean') return value ? 'Yes' : 'No';
  if (column === 'session_location' && typeof value === 'number') {
    return SESSION_LOCATION_LABELS[value] ?? String(value);
  }
  return String(value);
}

export interface DexCopyPreviewEntry {
  column: string;
  label: string;
  value: string;
}

// Preserves the order copy_preview's keys arrive in (the API builds it by iterating the
// occurrence's own field_tags, so this is already the tag order the DEX tab itself renders in).
export function formatDexCopyPreview(
  preview: Record<string, string | number | boolean | null> | null,
): DexCopyPreviewEntry[] {
  if (!preview) return [];
  return Object.entries(preview).map(([column, value]) => ({
    column,
    label: DEX_COPY_FIELD_LABELS[column] ?? column,
    value: formatDexCopyPreviewValue(column, value),
  }));
}
